
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Memberships"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"role"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"first_name"},"name":{"kind":"Name","value":"firstName"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"last_name"},"name":{"kind":"Name","value":"lastName"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"image_url_50"},"name":{"kind":"Name","value":"smallAvatarUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currencies"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"owner"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"first_name"},"name":{"kind":"Name","value":"firstName"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"last_name"},"name":{"kind":"Name","value":"lastName"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"image_url_50"},"name":{"kind":"Name","value":"smallAvatarUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currencies"},"arguments":[],"directives":[]}]}},{"kind":"Field","alias":{"kind":"Name","value":"report"},"name":{"kind":"Name","value":"permission"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"for"},"value":{"kind":"EnumValue","value":"REPORT"}}],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"manage_overview"},"name":{"kind":"Name","value":"permission"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"for"},"value":{"kind":"EnumValue","value":"MANAGE_OVERVIEW"}}],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"manage_add_ons"},"name":{"kind":"Name","value":"permission"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"for"},"value":{"kind":"EnumValue","value":"MANAGE_ADD_ONS"}}],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"promote"},"name":{"kind":"Name","value":"permission"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"for"},"value":{"kind":"EnumValue","value":"PROMOTE"}}],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"all_listings"},"name":{"kind":"Name","value":"allEvents"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"event_ids"},"name":{"kind":"Name","value":"eventIds"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"manage_fee_presets"},"name":{"kind":"Name","value":"permission"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"for"},"value":{"kind":"EnumValue","value":"MANAGE_FEE_PRESETS"}}],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":791}};
    doc.loc.source = {"body":"query Memberships($limit: Int, $offset: Int) {\n  viewer {\n   id\n    role\n    first_name: firstName\n    last_name: lastName\n    image_url_50: smallAvatarUrl\n    currencies\n    organization {\n      id\n    } \n    memberships {\n      nodes(limit: $limit, offset: $offset) {\n         id\n        owner {\n          id\n    \t\t\tfirst_name: firstName\n    \t\t\tlast_name: lastName\n    \t\t\timage_url_50: smallAvatarUrl\n          currencies\n        }\n        report: permission(for: REPORT)\n        manage_overview: permission(for: MANAGE_OVERVIEW)\n        manage_add_ons: permission(for: MANAGE_ADD_ONS)\n        promote: permission(for: PROMOTE)\n        all_listings: allEvents\n        event_ids: eventIds\n        manage_fee_presets: permission(for: MANAGE_FEE_PRESETS)\n      }\n      totalCount\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["Memberships"] = oneQuery(doc, "Memberships");
        
